import { LayoutComponent } from './components/layout/layout.component';
import { ThaiDatePipe } from './pipe/thai-date/thai-date.pipe';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ModalService } from './services/utils/modal.service';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzTableModule, NzTabsModule, NzTreeModule, NzDropDownModule, NzCheckboxModule, NzDividerModule, NzModalModule, NzLayoutModule, NzBreadCrumbModule, NzRadioModule } from 'ng-zorro-antd';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { PhonePipe } from './pipe/telephone/telephone.pipe';
import { DigitOnlyDirective } from './directive/digit-only/digit-only.directive';
import { TranslateModule, TranslateLoader, TranslateService, TranslatePipe } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { UtilsService } from './services/utils/utils.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { IdCardPipe } from './pipe/card/idcard.pipe';
// import { ValidationFieldComponent } from './components/validation-field/validation-field.component';
// import { ValidationMessageComponent } from './components/validation-message/validation-message.component';
import { ModalNoResultComponent } from './components/modal-no-result/modal-no-result.component';
import { SpinComponent } from './components/spin/spin.component';
import { Icd9Component } from './components/icd9/icd9.component';
import { Icd10Component } from './components/icd10/icd10.component';
import { NumbersOnlyDirective } from './directive/number-directive/number.directive';
import { Simb2545Component } from './components/simb-2545/simb-2545.component';
import { Simb2561Component } from './components/simb-2561/simb-2561.component';
import { ChangeSimbComponent } from './components/change-simb/change-simb.component';
import { UploadModalComponent } from './components/upload-modal/upload-modal.component';
import { GlobalService } from './services/global/global.service';
import { SelectedHospitalComponent } from './components/selected-hospital/selected-hospital.component';
import { MyDatePickerModule } from 'knes-datepicker';
import { NgxMaskModule } from 'ngx-mask';
import { NumberToTextService } from './services/utils/number-to-text.service';
import { WarningModalComponent } from './components/warning-modal/warning-modal.component';
import { ModalPrintInsuredReportComponent } from './components/modal-print-insured-report/modal-print-insured-report.component';
import { UploadUserModalComponent } from './components/upload-user-modal/upload-user-modal.component';
import { WarningLoginModalComponent } from './components/warning-login-modal/warning-login-modal.component';
import { AnnouncePasswordComponent } from './components/announce-password/announce-password.component';
import { ExpirePasswordComponent } from './components/expire-password/expire-password.component';

export function HttpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

export function customHttpLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

const _IMPORT_OTHERS = [
  /* import other lib at here */
  NzTableModule,
  NzTabsModule,
  NzTreeModule,
  NzDropDownModule,
  NzCheckboxModule,
  NzDividerModule,
  NzModalModule,
  NzSwitchModule,
  NzButtonModule,
  NgZorroAntdModule,
  NzBreadCrumbModule,
  NzCardModule,
  NzGridModule,
  NzLayoutModule,
  TranslateModule,
  AngularSvgIconModule,
  NzRadioModule,
  MyDatePickerModule,
  NgxMaskModule.forRoot(),

];

const _EXPORTS = [
  /* export at here */
  // Module
  NzTableModule,
  NzTabsModule,
  NzTreeModule,
  NzDropDownModule,
  NzCheckboxModule,
  NzDividerModule,
  NzModalModule,
  NzCardModule,
  NzGridModule,
  NzSwitchModule,
  NzBreadCrumbModule,
  NzButtonModule,
  NgZorroAntdModule,
  NzLayoutModule,
  TranslateModule,
  AngularSvgIconModule,
  NzRadioModule,
  MyDatePickerModule,
  NgxMaskModule.forRoot(),


  // Component
  LayoutComponent,
  // ValidationFieldComponent,
  // ValidationMessageComponent,
  ModalNoResultComponent,
  SpinComponent,
  Icd9Component,
  Icd10Component,
  Simb2545Component,
  Simb2561Component,
  ChangeSimbComponent,
  UploadModalComponent,
  SelectedHospitalComponent,
  WarningModalComponent,
  ModalPrintInsuredReportComponent,
  UploadUserModalComponent,
  WarningLoginModalComponent,
  AnnouncePasswordComponent,
  ExpirePasswordComponent,

  // Pipe
  ThaiDatePipe,
  PhonePipe,
  TranslatePipe,
  IdCardPipe,

  // Directive
  DigitOnlyDirective,
  NumbersOnlyDirective,

];

const _DECLARATIONS = [
  /* declaration shared component at here */
  // Component
  LayoutComponent,
  // ValidationFieldComponent,
  // ValidationMessageComponent,
  ModalNoResultComponent,
  SpinComponent,
  Icd9Component,
  Icd10Component,
  Simb2545Component,
  Simb2561Component,
  ChangeSimbComponent,
  UploadModalComponent,
  SelectedHospitalComponent,
  WarningModalComponent,
  ModalPrintInsuredReportComponent,
  UploadUserModalComponent,
  WarningLoginModalComponent,
  AnnouncePasswordComponent,
  ExpirePasswordComponent,

  // Pipe
  ThaiDatePipe,
  PhonePipe,
  IdCardPipe,

  // Directive
  DigitOnlyDirective,
  NumbersOnlyDirective,

];

const _PROVIDERS = [
  /* provider service at here */
  ModalService,
  NzModalService,
  TranslateService,
  UtilsService,
  GlobalService,
  NumberToTextService,
  DatePipe
];

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    _IMPORT_OTHERS
  ],
  exports: [
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    _EXPORTS
  ],
  declarations: [_DECLARATIONS, UploadModalComponent],
  providers: [_PROVIDERS]
})
export class SharedModule { }
